<script setup>
import LoginForm from "@/components/school/LoginForm.vue";
</script>

<template>
  <LoginForm />
</template>
